// src/services/wordpressApi.ts
import axios from "axios";

const WORDPRESS_API = "https://public-api.wordpress.com/rest/v1/sites/asklaxman.wordpress.com";

export const getPosts = async () => {
  const response = await axios.get(`${WORDPRESS_API}/posts`);
  return {
    data: response.data.posts,
    totalPages: response.data.found,
  };
};
